// extracted by mini-css-extract-plugin
export default {"title":"styles_title__mpeA4","title--pink":"styles_title--pink__JDbF-"};